export const iconNames = [
  'glaucoma',
  'ocular-surface',
  'cornea',
  'cataract',
  'oblique-amblyopia',
  'fundi-disease',
  'orbital-disease',
  'eye-traumas',
  'shortsightedness',
  'plastic',
  'general-1',
  'general-2',
  'general-3',
  'general-4',
  'general-5'
]


export const responsiveStyleValue = {
  // 隐藏“猜您想问”时，聊天内容距离底部的padding距离
  HIDDEN_KEYWORDS_PADDING_BOTTOM: 45,
  // 显示“猜您想问”时，聊天内容距离底部的padding距离
  SHOW_KEYWORDS_PADDING_BOTTOM: 80,
  // 显示“您可能想问”时，聊天内容的relative-top距离
  SHOW_QUESTIONS_RELATIVE_TOP: -33
}

// 换肤模版iconName
export const iconNamesColor = [
  'eye-protection',
  'cataract1',
  'laser-surgery',
  'strabismus',
  'glaucoma1',
  'sugar-net',
  'conjunctivitis',
  'species1',
  'species2',
  'species3',
  'species4',
  'species5',
  'species6',
  'species7',
  'species8'
]

// 中山模版
export const TEMPLATE_ZHONG_SHAN = 'zhongshan';

// 通用模版
export const TEMPLATE_VISTEL = 'vistel';

// 可换颜色模版
export const TEMPLATE_COLOR_THEME = 'colortheme';

// 可换颜色+导诊模版
export const TEMPLATE_COLOR_THEME_GUIDE = 'colorful-guide';

// 通用+导诊模版
export const TEMPLATE_GUIDE = 'guide';

// 河南省立眼科模版（基于可换颜色模版）
export const TEMPLATE_LI_YAN_KE = 'liyanke';

// 后台返回的模版映射,后续添加模版需在这里配置
export const TEMPLATE_REPLECT = {
  'zhongshan': TEMPLATE_ZHONG_SHAN,
  'vistel': TEMPLATE_VISTEL,
  'colorful-theme': TEMPLATE_COLOR_THEME,
  'colorful-guide': TEMPLATE_COLOR_THEME_GUIDE,
  'guide': TEMPLATE_GUIDE,
  'liyanke': TEMPLATE_LI_YAN_KE
}

// 康明眼科医院人工客服链接
export const KMYK_SERVICE_URL = 'https://dvt.zoosnet.net/LR/Chatpre.aspx?id=DVT16479667';


// 再次打开调查问卷的有效期为1天
export const REOPEN_QUESTIONNAIRE_EXPIRE_TIME = 1;
// 累计使用时间不能少于15秒
export const MIN_USE_TIME = 15000;

// 河南省立眼科医院的调查问卷链接
export const HNSRMYY_QUESTIONNAIRE_URL = "https://www.wjx.cn/m/76934079.aspx";
// 河南省立眼科医院的机构ID
export const HNSRMYY_ORGANIZATION_UID = "hnsrmyy";
// 干眼门诊的中文名称
export const DRY_EYE_CLINIC_CN_NAME = "干眼门诊";



// WEBPACK FOOTER //
// ./src/utils/constant.js